<template>
  <div class="pager">
    <yxt-pagination
      class="pull-right"
      simple-total
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pager.pageSize"
      layout="total, prev, pager, next"
      v-bind="pageOption"
      :total="pager.total"
    >
    </yxt-pagination>
  </div>
</template>

<script>
import { Pagination } from 'yxt-pc';
export default {
  components: {
    YxtPagination: Pagination
  },
  data() {
    return {
      // pageSize: 20,
      currentPage: 1,
      isDisabled: false
    };
  },
  props: ['pager', 'total', 'pages', 'pageSize', 'offset', 'pageOption'],
  computed: {
    // layout () {
    //   if (this.pager) {
    //     return this.pager.total ? 'jumper,slot,sizes,next,pager,prev' : 'jumper,slot,sizes,pager'
    //   } else {
    //     return 'jumper,slot,sizes,next,pager,prev'
    //   }
    // }
  },
  methods: {
    // 分页pageSize变化时
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pager.pageSize = val;
      this.$emit('handleSizeChange', val);
      this.$emit('searchData');
    },
    // 分页当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.pager.offset = (this.currentPage - 1) * this.pager.pageSize;
      this.$emit('searchData');
    },
    // 设置disabled
    setDisabled(val) {
      this.isDisabled = val;
    }
  },
  mounted() {
    if (this.pager.total === 0) {
      this.currentPage = 0;
    }
  },
  watch: {
    pager: {
      handler: function(val) {
        if (val.offset === 0) {
          this.currentPage = 1;
        }
      },
      deep: true
    }
  }
};
</script>

